
import { DropdownItem } from "@/types/dropdown";
import SearchDropdownButtonItem from "@/components/search/SearchDropdownButtonItem.vue";
import { defineComponent, SetupContext, ref, PropType } from "vue";

export default defineComponent({
  name: "SearchDropdownList",
  components: { SearchDropdownButtonItem },
  props: {
    /**
     * ドロップダウンリスト
     */
    dropdownList: {
      type: Array as PropType<DropdownItem[]>,
      required: true
    },
    /**
     * ソート順
     */
    selectType: {
      type: String,
      default: "",
      required: true
    }
  },
  setup(props, context: SetupContext) {
    const selectType = ref(props.selectType);
    /**
     * 選択されたタグを通知する
     */
    const selectItem = (label: string) => {
      let type = "";
      props.dropdownList.forEach(e => {
        if (e.label == label) {
          type = e.type;
        }
      });
      selectType.value = type;
      context.emit("select-item", type);
    };

    /**
     * ソート名を取得する
     */
    const getSelectLabel = () => {
      let label = "";
      props.dropdownList.forEach(e => {
        if (e.type == selectType.value) {
          label = e.label;
        }
      });
      return label;
    }

    return {
      selectItem,
      getSelectLabel
    };
  }
});
